import T from './table';
import ProductTable from './elements';
import { Link } from '@uswitch/ev-core/react';
import { getValue } from './utils';
import sw from '@uswitch/ev-utils/switch';
import { path } from '@uswitch/ev-utils/obj';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var CellFormatter = sw({
  default: function _default(_ref) {
    var cell = _ref.cell,
        data = _ref.data;
    return (// eslint-disable-next-line react/jsx-pascal-case
      _jsx(ProductTable.text.Value, {
        value: getValue(cell.value, data),
        unit: getValue(cell.unit, data),
        subscript: getValue(cell.subscript, data)
      })
    );
  }
});
var HTMLCell = sw({
  'cells.Split': function cellsSplit(_ref2) {
    var cell = _ref2.cell,
        data = _ref2.data,
        key = _ref2.key;
    return cell.contents.map(function (content, j) {
      return HTMLCell(content.type, {
        cell: content,
        data: data,
        key: "".concat(key, "-").concat(j)
      });
    }, this);
  },
  'cells.Content': function cellsContent(_ref3) {
    var cell = _ref3.cell,
        data = _ref3.data,
        key = _ref3.key;
    return _jsx(T.td, {
      children: CellFormatter(cell.content.type, {
        cell: cell.content,
        data: data
      })
    }, key);
  },
  default: null
});
var HTMLHeading = sw({
  'cells.Split': function cellsSplit(_ref4) {
    var cell = _ref4.cell,
        data = _ref4.data,
        key = _ref4.key;
    return cell.contents.map(function (content, j) {
      return HTMLHeading(content.type, {
        cell: content,
        data: data,
        key: "".concat(key, "-").concat(j)
      });
    }, this);
  },
  'cells.Content': function cellsContent(_ref5) {
    var cell = _ref5.cell,
        key = _ref5.key;
    return _jsx(T.th, {
      children: path(['heading', 'value'], cell)
    }, key);
  },
  default: null
});

var ProductTableHtml = function ProductTableHtml(_ref6) {
  var data = _ref6.data,
      _ref6$header = _ref6.header,
      header = _ref6$header === void 0 ? {} : _ref6$header,
      _ref6$grid = _ref6.grid,
      grid = _ref6$grid === void 0 ? {
    contents: []
  } : _ref6$grid;
  return _jsxs(T.wrap, {
    children: [_jsxs(T.tr, {
      children: [_jsx(T.th, {
        children: "Product name"
      }), grid.contents.map(function (cell, key) {
        return HTMLHeading(cell.type, {
          key: key,
          cell: cell
        });
      }, this)]
    }), data.map(function (product, id) {
      return _jsxs(T.tr, {
        children: [_jsx(T.td, {
          children: grid.contents.find(function (_ref7) {
            var id = _ref7.id;
            return id === 'cells.Cta';
          }) ? _jsx(Link, {
            href: getValue(grid.contents.find(function (_ref8) {
              var id = _ref8.id;
              return id === 'cells.Cta';
            }).primary.href, product),
            children: getValue(header.title, product)
          }) : getValue(header.title, product)
        }), grid.contents.map(function (cell, key) {
          return HTMLCell(cell.type, {
            key: key,
            cell: cell,
            data: product
          });
        }, this), grid.contents.filter(function (_ref9) {
          var id = _ref9.id;
          return id === 'cells.Cta';
        }).map(function (cell, key) {
          return _jsx(T.td, {}, key);
        }, this)]
      }, id);
    }, this)]
  });
};

export default ProductTableHtml;
//# sourceMappingURL=product-table-html.js.map